<teams [resourceType]="resourceType"></teams>
